export default __webpack_public_path__ + "static/media/eps.d0798f1b.svg";